<label [attr.id]="inputId" class="pg-switch-container grit-switch-container" #label>
  <div
    #switchBar
    class="pg-switch-bar"
    [style.background]="styleOverrides?.offBackgroundColor"
  >
    <span
      [style.background]="styleOverrides?.onBackgroundColor"
      class="pg-switch-fill-background"
    ></span>
    <input
      #input
      role="switch"
      class="pg-switch-input pg-visibly-hidden"
      type="checkbox"
      role="switch"
      [id]="inputId"
      [checked]="checked"
      [attr.name]="name"
      [attr.aria-checked]="checkedStr"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledby"
      (change)="_onChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      tabindex="1"
    />

    <div
      #thumb
      class="pg-switch-thumb"
      [class.is-focused]="_isFocused"
      [class.thumb-active]="isActive"
      (slideend)="_onDragEnd()"
      (slidestart)="_onDragStart()"
      (slide)="_onDrag($event)"
    >
      <span
        class="pg-switch-fill"
        [style.background]="styleOverrides?.thumbBackgroundColor"
      >
      </span>
    </div>
  </div>
  <div
    *ngIf="onLabel && offLabel"
    class="pg-labels-container"
    @blockInitial
    [class.pg-switch-label-bottom]="labelPosition === 'bottom'"
  >
    <div
      [@OffTrigger]="offLabelState"
      #labelOffContent
      class="pg-switch-label off-label"
      [style.color]="styleOverrides?.labelColor"
      [style.fontWeight]="styleOverrides?.labelFontWeight"
      [style.fontFamily]="styleOverrides?.labelFontFamily"
    >
      <ng-content select="pg-off-label, grit-off-label"></ng-content>
    </div>
    <div
      #labelOnContent
      [@OnTrigger]="onLabelState"
      class="pg-switch-label on-label"
      [style.color]="styleOverrides?.labelColor"
      [style.fontWeight]="styleOverrides?.labelFontWeight"
      [style.fontFamily]="styleOverrides?.labelFontFamily"
    >
      <ng-content select="pg-on-label, grit-on-label"></ng-content>
    </div>
  </div>
</label>
